import { Directive, Input, inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { DataTableService } from './data-table.service';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {StorageService} from "../../../services/storage.service";
import {NotificationService} from "../../../services/notification.service";
import {DataService} from "../../../services/data.service";
import {DialogService} from "../../../services/dialog.service";
import {FilesService} from "../../../services/files.service";
import {AppState} from "../../../store";
import {AuthService} from "../../../services/auth.service";
import {AllDetailsService} from "../all-details/all-details.service";
import {SettingsService} from "../../../services/settings.service";
import {FieldsService} from "../../../services/fields.service";
import {MtxGridColumn, MtxGridRowClassFormatter} from "@ng-matero/extensions/grid";

@Directive()
export class DataTableDirective{
  // Services
   storage = inject(StorageService);
   apollo = inject(Apollo);
   auth = inject(AuthService);
   notify = inject(NotificationService);
   filesService = inject(FilesService);
   ds = inject(DataService);
   fs = inject(FieldsService);
   as = inject(AllDetailsService);
   vs = inject(DialogService);
   ts = inject(DataTableService);
   st = inject(SettingsService);
   actions$ = inject(Actions);
   store = inject(Store<AppState>);

  //  properties
  @Input() columns:MtxGridColumn[] = [];
  initialColumns:MtxGridColumn[] = [];

  // functionalities
  @Input() multiSelectable = true;
  @Input() rowSelectable = false;
  @Input() hideRowSelectionCheckbox = false;
  @Input() showToolbar = true;
  @Input() showFilters = true;
  @Input() columnHideable = true;
  @Input() columnSortable = true;
  @Input() columnPinnable = true;
  @Input() rowHover = true;
  @Input() rowStriped = false;
  @Input() showPaginator = false;
  @Input() expandable = false;
  @Input() columnResizable = true;
  @Input() dataType = 'Data';


  @Input() showTableControls = false;
  @Input() showTableFilters = true;
  @Input() canChangeDisplayedColumns = false;

  @Input() showDateRangeFilter = false;
  @Input() showDateFilter = false;
  @Input() showSearchStates = true;
  @Input() alwaysShowFilter = true;
  @Input() showSearchInput = true;
  @Input() canExportData = true;
  @Input() useDateRangeFilter = false;


  @Input() rowClassFormatter: MtxGridRowClassFormatter = {
    cool: (data, index) => data === null,
  };

  @Input() contentEditable = false;

  showControls = false;
  private settings: SettingsService;


  // col to host expansion toggle
  updateXpCol() {
    this.columns[1].showExpand = this.expandable;
  }

  setMtxColumns(columnHeader){
    if(!columnHeader) return;

    const columns:MtxGridColumn[] = [];
    const fields = this.fs.fieldsArrayFromObj(columnHeader);

    fields.forEach((field,index)=> {
      const column:MtxGridColumn = {header:field.value, field:field.key};
      if(index === 0) column.pinned = 'left';
      if(this.ds.valueIncludes(column.field,['index','no.','sno.','sn.'])) column.width = '64px';

      if(this.ds.valueIncludes(column.header,['action'])){
         column.pinned = 'right';
         column.width = '100px';
      }
      columns.push(column);
    });

    // replace columns by  actual initial columns if present
    columns.map(column => this.initialColumns.find(c => c.field === column.field) ?? column);
    this.columns = columns;
    this.updateXpCol();
  }

  toggleTableControls(show?){
    this.showTableControls = show ?? !this.showTableControls;
  }

  toggleTableFilters(show?){
    this.showTableFilters = show ?? !this.showTableFilters;
  }

  toggleCanChangeDisplayedColumns(show?){
    this.canChangeDisplayedColumns = show ?? !this.canChangeDisplayedColumns;
  }

  toggleOptions(){
    this.settings.multipleClickEvent(() => {
      this.canChangeDisplayedColumns = !this.canChangeDisplayedColumns;
      this.useDateRangeFilter = !this.useDateRangeFilter;
    }, 7);
  }

  toggleControls(){
    this.st.multipleClickEvent(()=>{
      this.showControls = !this.showControls;
      this.toggleTableControls(this.showControls);
      this.toggleTableFilters(this.showControls);
      this.toggleCanChangeDisplayedColumns(this.showControls);
      this.showDateRangeFilter = this.showControls;
      this.showDateFilter = this.showControls;
      this.alwaysShowFilter = this.showControls;
      this.canExportData = this.showControls;
      this.showToolbar = this.showToolbar;
      this.showFilters = this.showControls;
    }, 7);
  }


}
